import React, { useCallback, useState } from 'react';
import lscache from 'lscache';

import { Document } from 'src/common/interfaces/document.interface';

export const useDocumentEditorSpotlights = () => {
  const [spotlightOpen, setSpotlightOpen] = useState(true);

  const isEmptyDocument = useCallback((document: Document) => {
    return document.blocks.length <= 1;
  }, []);

  const setSeen = useCallback((key) => {
    lscache.supported() && lscache.set(key, true);
  }, []);

  const setSeenEmptyDocumentEditorSpotlight = () => {
    setSeen('empty_document_editor_spotlight');
    setSpotlightOpen(false);
  };

  const showEmptyDocumentEditorSpotlight = useCallback(
    (document: Document) => {
      return (
        isEmptyDocument(document) &&
        (!lscache.supported() || !lscache.get('empty_document_editor_spotlight')) &&
        spotlightOpen
      );
    },
    [isEmptyDocument, spotlightOpen]
  );

  return {
    setSeenEmptyDocumentEditorSpotlight,
    showEmptyDocumentEditorSpotlight,
  };
};
